import React, { useState, Fragment } from 'react'

import AdditionsList from './AdditionsList'
import AdditionDetails from './AdditionDetails'
import { listProductAdditions } from '../../../gql/query'
import { Form } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import { useListQuery } from 'components/graphql'
import fetchedDataToForm from 'helpers/fetchedDataToForm'

const Additions = ({ productAdditions, onChange, productId }) => {
	const [selectedId, setSelectedId] = useState(null)
	const { data: allAdditions, client } = useListQuery(listProductAdditions)

	const handleFormChange = ({ additions = [], ...restVals }) => {
		// Don't send items which haven't been updated
		const mutationVals = {
			...restVals,
			additions: additions.filter(({ id, ...rest }) => (!id || (id && !Object.keys(rest).length)))
		}
		onChange(mutationVals)
	}

	let detailsData = selectedId === 'NEW_RECORD' ?
		{} : allAdditions.find(({ id }) => id === selectedId)

	const key = Array.isArray(productAdditions) ? productAdditions.reduce((sum, { mod_ver }) => sum + Number(mod_ver), 0) : 0
	return(
		<Fragment>
			<ContentBlock>
				<Form key={key} initialValues={{ additions: productAdditions }} onSubmit={handleFormChange} reinitByModVer={false} smartSubmit>
					<AdditionsList
						field='additions'
						listAdditions={allAdditions}
						listAdditionsQuery={listProductAdditions}
						client={client}
						onSelect={(data, delId) => {
							// Set selected item data or a new item to the form data
							if(data) {
								setSelectedId(data.id || 'NEW_RECORD')
							}
							// Close form data if deleted item is currently open
							if(delId === selectedId) {
								setSelectedId(null)
							}
						}}
						productId={productId} />
				</Form>
			</ContentBlock>
			{detailsData &&
				<AdditionDetails
					data={fetchedDataToForm(detailsData)}
					listAdditionsQuery={listProductAdditions}
					closeForm={() => setSelectedId(null)}
				/>
			}
		</Fragment>
	)
}

export default Additions
